module.exports = __webpack_public_path__ + "img/MES11Indice4.51324e01.png";